export enum DeviceConfigurationStatus {
  CURRENT = 'current',
  PENDING = 'pending',
  PUBLISHED = 'published',
  DELETED = 'deleted',
  ERROR = 'error'
}
